export { default as Login } from './Login';
export { default as Registration } from './Registration';
export { default as ForgottenPw } from './ForgottenPw';
export { default as RecoverPw } from './RecoverPw';


// WEBPACK FOOTER //
// ./src/components/Query/User/index.tsx